import { render, staticRenderFns } from "./FormPagamento.vue?vue&type=template&id=3fe7e287"
import script from "./FormPagamento.vue?vue&type=script&lang=ts"
export * from "./FormPagamento.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports